import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PublishDate = makeShortcode("PublishDate");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The most recent developments to the Earthworks Gondwana dispersal model have
been used to  derive two series of high-resolution images that are released
today `}<a parentName="p" {...{
        "href": "/reevesdotnl/"
      }}>{`[`}{`here`}{`]`}</a>{`. The model,  CR20ABAW, incorporates the most recent thinking
on the early opening of the South Atlantic  Ocean, the articulation of Patagonia by
closing the Early Cretaceous rift basins there and the  refinement of movements
along the Agulhas fault zone off the coast of South Africa and its newly defined
conjugate in South America. The rationale will be explained in a future Research
Update. Meanwhile, the main points will be set out in a poster presentation at
the Netherlands  Earth Science Congress `}<a parentName="p" {...{
        "href": "https://nacgeo.nl/"
      }}>{`[`}{`nacgeo.nl/`}{`]`}</a>{` in Utrecht, March 12-13.
The abstract accepted for the  poster presentation is given below and the poster
itself in an A4 version may be  accessed `}<a parentName="p" {...{
        "href": "/reevesdotnl/"
      }}>{`[`}{`here`}{`]`}</a>{`. The poster was shown shortly
before the congress was cut short by measures to  contain coronavirus. The
geology shown in the accompanying figure is courtesy of the Gondwana  Map
Project (IGCP-628). `}</p>
    <PublishDate updated="2020-03-25" mdxType="PublishDate" />
    <h1>{`African geology, the Bouvet mantle plume and the early opening of the Gondwana margins`}</h1>
    <p>{`Fifty years of detailed geophysical mapping of Africa’s hidden geology (in
support of logical resource  development policies) has revealed many
continental-scale features of global significance. These include one  of the
world’s largest dyke swarms (Okavango, 178 Ma), the Morokweng meteorite impact
(145 Ma, Jurassic Cretaceous boundary) and new intra-continental rift systems
and shear zones (135-128 Ma). In the context of  the new geological map of
re-assembled Gondwana (IGCP-628) this has led to a refined model of Gondwana
break-up and dispersal in Jurassic and Early Cretaceous times. Essential to the
geodynamic model is  interpretation of ocean-floor topography derived from
satellite gravimetry in conjunction with sparse marine  magnetic anomaly data
from before the Cretaceous Quiet Zone (84-126 Ma). The ongoing role of the
Bouvet  mantle plume emerges as the central theme to this process, from the
initial large igneous province (circa 183  Ma), through a ridge reorganisation
at 135 Ma to the eruption of the Iceland-like Agulhas plateau basalts at  about
100 Ma, as well the subsequent history of the associated triple junction.
Whereas the outbreak of the  Tristan plume (135 Ma) is often given credit for
the opening of the South Atlantic Ocean, the more southerly  parts of the
proto-ocean were manifestations of pre-135 Ma Bouvet plume activity. The
geodynamic model is  illustrated by animations, also available on the website
`}<a parentName="p" {...{
        "href": "/reevesdotnl/gondwana"
      }}>{`http://reeves.nl/gondwana`}</a>{`. Delineation of sub-plates  within the
Patagonia region of South America remains enigmatic.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      